import styled from 'styled-components';

export default () => <Text>You won&apos;t be charged yet</Text>;

const Text = styled.div`
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  border-top: 1px solid rgba(219, 223, 229, 0.5);
  color: #5e696a;
  padding-top: 25px;
`;
